import type { CSSProperties, ReactNode } from 'react';
import styles from './CompactStat.module.css';

/**
 * A single compact KPI: label + value (+ optional hint / legend dot). A smaller
 * alternative to the design-system `Stat` (which renders at 2xl) — used on
 * resource-detail consoles where the large number reads oversized.
 */
export function CompactStat({
  label,
  value,
  hint,
  dotColor,
}: {
  label: ReactNode;
  value: ReactNode;
  hint?: ReactNode;
  dotColor?: string;
}) {
  return (
    <div className={styles.stat}>
      <span className={styles.label}>
        {dotColor ? <span className={styles.dot} style={{ background: dotColor }} /> : null}
        {label}
      </span>
      <span className={styles.value}>{value}</span>
      {hint ? <span className={styles.hint}>{hint}</span> : null}
    </div>
  );
}

/** Grid wrapper for {@link CompactStat} — mirrors the DS `StatGroup` columns API. */
export function CompactStatGroup({
  columns = 3,
  style,
  children,
}: {
  columns?: number;
  style?: CSSProperties;
  children: ReactNode;
}) {
  return (
    <div className={styles.group} style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`, ...style }}>
      {children}
    </div>
  );
}
